module.exports = __webpack_public_path__ + "img/portfolio-01.7773eb14.jpg";